import React from 'react';
import PropTypes from 'prop-types';
import gifSEImage from 'assets/images/StreamElementsTutorial/gif_SE_step_6.gif';
import { TutorialImage } from 'styles/TutorialImages';
import Text from 'components/Text';

import StepContent from '../../../components/StepContent';

const Step9 = ({ processStep, goPrev }) => (
  <StepContent provider="stream_elements" processStep={processStep} goPrev={goPrev}>
    <Text lineHeight={1.58} align="center" mb={20}>
      Skopiuj teraz link do płatności StreamElements, aby wkleić go w następnym kroku. Będzie on
      potrzebny do integracji płatności.
    </Text>
    <TutorialImage style={{ marginBottom: 32 }} src={gifSEImage} />
  </StepContent>
);

export default Step9;

Step9.propTypes = {
  processStep: PropTypes.instanceOf(Function).isRequired,
  goPrev: PropTypes.instanceOf(Function).isRequired,
};
